import * as Types from 'src/actions/project/comments/create/Types';
import { CreateProjectCommentAction } from 'src/actions/project/comments/create/CreateProjectComment.actions';

export interface CreateProjectCommentState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: CreateProjectCommentState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function CreateProjectCommentReducer(state: CreateProjectCommentState = initialState,
                                            action: CreateProjectCommentAction): CreateProjectCommentState {
  switch (action.type) {
    case Types.CREATE_PROJECT_COMMENT_ATTEMPT:
      return {...state, loading: true, error: false};
    case Types.CREATE_PROJECT_COMMENT_SUCCESS:
      return {...state, loading: false, error: false};
    case Types.CREATE_PROJECT_COMMENT_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/comments/CreateProjectCommentsReducer.tsx